var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Preview',{attrs:{"show":_vm.innerShow},on:{"change":_vm.onPreviewChange}})}
var staticRenderFns = []

export { render, staticRenderFns }